import {
  Combined1500ComponentLineItem,
  ICombined1500ComponentLineItem,
} from './Combined1500ComponentLineItem'

export interface ICombined1500ComponentDetail {
  providerTypeAbbreviation: string
  invoiceUsualAndCustomaryTotal: number
  lineItems: ICombined1500ComponentLineItem[]
}

export class Combined1500ComponentDetail implements ICombined1500ComponentDetail {
  public providerTypeAbbreviation: string
  public invoiceUsualAndCustomaryTotal: number = 0
  public lineItems: ICombined1500ComponentLineItem[] =
    new Array<Combined1500ComponentLineItem>()
}
